import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { FiDocumentViewStateComponent } from '@fi-app/document/document-view-state/document-view-state.component';
import { FiDocumentStatesResolvePageTitle } from '@fi-app/document/states/resolve/document-page-title';
import { DocumentService } from '@fi-app/document/document.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

const DocumentViewCommentIdResolver = [
    FiStateService,
    Transition,
    (fiStateService: FiStateService, $transition$: Transition) => {
        return fiStateService.getParams($transition$).commentId;
    },
];

export const FiDocumentViewState: Ng2StateDeclaration = {
    name: FiStateNames.Document.View,
    url: '/:Id?commentId&languageId&focusNewComment&highlightText',
    reloadOnSearch: false,
    views: {
        '@': {
            component: FiDocumentViewStateComponent,
        },
    },
    params: {
        commentId: undefined,
    },
    resolve: {
        document: [DocumentService, FiStateService, Transition, FiDocumentViewStateResolveDocumentResolveFunc],
        highlightText: [FiStateService, Transition, FiDocumentViewStateResolve_highlightText],
        pageTitle: FiDocumentStatesResolvePageTitle,
        focusNewComment: [FiStateService, Transition, DocumentViewFocusNewComment],
        commentId: DocumentViewCommentIdResolver,
    },
};

export function FiDocumentViewStateResolveDocumentResolveFunc(
    documentService: DocumentService,
    fiStateService: FiStateService,
    $transition$: Transition,
) {
    return documentService.GetDocument(fiStateService.getParams($transition$).Id, true);
}

export function DocumentViewFocusNewComment(fiStateService: FiStateService, $transition$: Transition) {
    return fiStateService.getParams($transition$).focusNewComment;
}

export function FiDocumentViewStateResolve_highlightText(fiStateService: FiStateService, $transition$: Transition) {
    return fiStateService.getParams($transition$).highlightText;
}
